import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpEformService} from "../../global/HttpEformService";
import {
  EndorsementNonFinancialRequestModel, EndorsementNonFinancialResponseModel,
  EndorsementRequestModel,
  EndorsementResponseModel
} from "../model/endorsement.model";

@Injectable({
  providedIn: 'root'
})
export class EndorsementService extends HttpEformService {

  constructor(protected override http: HttpClient) {
    super(http)
  }

  endorsement(request: EndorsementRequestModel): Observable<EndorsementResponseModel> {
    let url = this.url + "endorsement";
    // let url = "http://localhost:8302/covering/dashboard";
    return this.http
      .post<EndorsementResponseModel>(url, request);
  }

  endorsementNonFinancial(request: EndorsementNonFinancialRequestModel): Observable<EndorsementNonFinancialResponseModel> {
    let url = this.url + "endorsement-non-financial";
    // let url = "http://localhost:8302/covering/dashboard";
    return this.http
      .post<EndorsementNonFinancialResponseModel>(url, request);
  }
}
